<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">

  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Cookie-uri</h1>

  <div class="row">
    <div class="col-md-10">

      <h2 class="h1 pb-2">1. Politica de utilizare Cookie-uri</h2>
      <p>Aceasta politica se refera la cookie-urile si paginile web operate de S.C. IT INNOVATION CORP cu
        sediul social in Bucuresti, Bld. Tineretului nr. 49, bl. 58, sc. 2, sector 4 , denumita in continuare
        GiftShare.ro </p>
      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">2. Ce este un Cookie?</h2>
      <p>Cookie-ul este un fisier de mici dimensiuni, format din litere si numere, care va fi stocat pe
        computerul,
        terminalul mobil sau alte echipamente ale unui utilizator de pe care se acceseaza internetul.
        Cookie-ul este instalat prin solicitarea emisa de catre un web-server unui browser (ex: Internet
        Explorer, Chrome) si este complet “pasiv” (nu contine programe software, virusi sau spyware si
        nu poate accesa informatiile de pe hard driverul utilizatorului). </p>
      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">3. La ce sunt folosite Cookie-urile?</h2>
      <p>Aceste fisiere fac posibila recunoasterea terminalului utilizatorului si prezentarea continutului
        intr-un mod relevant, adaptat preferintelor utilizatorului. Cookie-urile asigura utilizatorilor
        o experienta placuta de navigare si sustin eforturile GiftShare.ro pentru a oferi servicii comfortabile
        utilizatorilor: ex: – preferintele in materie de confidentialitate online, cosul de cumparaturi
        sau publicitate relevanta. De asemenea, sunt utilizate in pregatirea unor statistici anonime
        agregate care ne ajuta sa intelegem cum un utilizator beneficiaza de paginile noastre web, permitandu-ne
        imbunatatirea structurii si continutului lor, excluzand indentificarea personala a utilizatorului.</p>
      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">4. Ce Cookie-uri folosim?</h2>
      <p>Folosim doua tipuri de Cookie-uri: per sesiune si fixe. Cele per sesiune sunt fisiere temporare ce
        raman in terminalul utilizatorului pana la terminarea sesiunii sau inchiderea aplicatiei (browser-ului
        web). Cele fixe raman pe terminalul utilizatorului pe o perioada definita de parametrii Cookie-ului
        sau pana sunt sterse manual de utilizator.</p>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">5. Cum sunt folosite cookie-urile de catre acest site?</h2>
      <p>O vizita pe acest site poate plasa cookie-uri in scopuri de:</p>
      <ul>
        <li>Cookie-uri de performanta a site-ului;</li>
        <li>Cookie-uri de analiza a vizitatorilor;</li>
        <li>Cookie-uri de inregistrare;</li>
        <li>Cookie-uri pentru publicitate;</li>
        <li>Cookie-uri ale furnizorilor de publicitate;</li>
      </ul>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">6. Contin Cookie-urile date personale?</h2>
      <p>Cookie-urile in sine nu solicita informatii cu caaracter personal pentru a putea fi utilizate si,
        in cele mai multe cazuri, nu identifica personal utilizatorii de internet. Datele personale colectate
        prin utilizarea Cookie-urilor pot fi colectate doar pentru a facilita anumite functionalitati
        pentru utilizator. Atare date sunt criptate intr-un mod care face imposibil accesul persoanelor
        neautorizate la ele.</p>
      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">7. Stergerea Cookie-urilor</h2>
      <p>In general, o aplicatie folosita pentru accesarea paginilor web permite salvarea Cookie-urilor pe
        terminal in mod implicit. Aceste setari pot fi schimbate in asa fel incat administrarea automata
        a Cookie-urilor sa fie blocata de browser-ul web sau utilizatorul sa fie informat de fiecare
        data cand Cookie-uri sunt trimise catre terminalul sau. Informatii detaliate despre posibilitatile
        si modurile de administrare a Cookie-urilor pot fi gasite in zona de setari a aplicatiei (browser-ului
        web). Limitarea folosirii Cookie-urilor poate afecta anumite functionalitati ale paginii web.</p>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">8. De ce sunt cookie-urile importante pentru Internet?</h2>
      <p>Cookie-urile reprezinta punctul central al functionarii eficiente a Internetului, ajutand la generarea
        unei experiente de navigare prietenoase si adaptata preferintelor si intereselor fiecarui utilizator.
        Refuzarea sau dezactivarea cookieurilor poate face unele site-uri imposibil de folosit. Refuzarea
        sau dezactivarea cookie-urilor nu inseamna ca nu veti mai primi publicitate online – ci doar
        ca aceasta nu va mai putea tine cont de preferintele si interesele dvs, evidentiate prin comportamentul
        de navigare.</p>
      <p>Exemple de intrebuintari importante ale cookieurilor (care nu necesita autentificarea unui utilizator
        prin intermediul unui cont):</p>
      <ul>
        <li>Continut si servicii adaptate preferintelor utilizatorului – categorii de produse si servicii.</li>
        <li>Oferte adaptate pe interesele utilizatorilor – retinerea parolelor.</li>
        <li>Retinerea filtrelor de protectie a copiilor privind continutul pe Internet (optiuni family
          mode,functii
          de safe search).</li>
        <li>Limitarea frecventei de difuzare a reclamelor – limitarea numarului de afisari a unei reclame
          pentru un anumit utilizator pe un site.</li>
        <li>Furnizarea de publicitate mai relevanta pentru utilizator.</li>
        <li>Masurarea, optimizarea si caracteristicile de analytics – cum ar fi confirmarea unui anumit nivel
          de trafic pe un website, ce tip de continut este vizualizat si modul cum un utilizator ajunge
          pe un website (ex prin motoare de cautare, direct, din alte website-uri etc). Website-urile
          deruleaza aceste analize a utilizarii lor pentru a imbunatati site-urile in beneficiul userilor.</li>
      </ul>


    </div>
  </div>

</section>
